import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

import { DoctorIncentiveTestingService } from '../../../services/index';
import { AddEditDoctorIncentiveTestingComponent } from './addEditDoctorIncentiveTesting.component';

@Component({
    selector: 'doctor-incentive-testing-tab',
    templateUrl: './doctorIncentiveTesting.component.html',
})
export class DoctorIncentiveTestingMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    doctorIncentiveTestingData: any[] = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'cr.name',
        orderDir: 'asc'
    };

    filterData = { search_data: '' };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    constructor(
        private doctorIncentiveTestingService: DoctorIncentiveTestingService,
        private modalService: BsModalService,
        public toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Doctor Name', prop: 'doctor_name', cellClass: 'cell-left', width: 300, minWidth: 300, maxWidth: 300 },
            { name: 'Incentive %', prop: 'incentive_percentage', cellClass: 'cell-right', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Start Date', prop: 'start_date', cellClass: 'cell-center', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'End Date', prop: 'end_date', cellClass: 'cell-center', width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Status', prop: 'status', cellClass: 'cell-left', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Action', prop: 'id', width: 105, minWidth: 105, maxWidth: 105, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (this.suppressPaging) { return; }
        this.page.offset = pageInfo.offset;
        this.getDoctorIncentiveTestingList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getDoctorIncentiveTestingList();
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    onOpenedFilter(): void {
        setTimeout(function() { $('#filterSearch').focus(); }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getDoctorIncentiveTestingList();
    }

    clearFilter(): void {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getDoctorIncentiveTestingList();
    }

    getDoctorIncentiveTestingList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.doctorIncentiveTestingService
            .getDoctorIncentiveTestingList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.doctorIncentiveTestingData = res.data;
            });
    }

    downloadCurrentData(): void {
        let params = {
            start: '0',
            limit: '99999',
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        this.doctorIncentiveTestingService.getDoctorIncentiveTestingList(params).then((res: any) => {
            const rows = (res.data || []).map(r => ({
                'DOCTOR NAME':  r.doctor_name,
                'INCENTIVE %':  r.incentive_percentage,
                'START DATE':   r.start_date,
                'END DATE':     r.end_date,
                'STATUS':       r.status
            }));
            const ws = XLSX.utils.json_to_sheet(rows);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            XLSX.writeFile(wb, 'Doctor_Incentive_Testing_' + moment().format('DD-MM-YYYY') + '.xlsx');
        });
    }

    bsModalRef: BsModalRef;
    public onAddEditDoctorIncentiveTesting(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditDoctorIncentiveTestingComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg'
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Doctor Incentive-Testing';
        this.bsModalRef.content.doctorIncentiveTestingData = Object.assign({}, row);
        this.bsModalRef.content.doctorIncentiveTestingLoadEvent.subscribe(($e) => {
            that.getDoctorIncentiveTestingList();
        });
    }

    onDeleteDoctorIncentiveTesting(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this record Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.doctorIncentiveTestingService
                .deleteDoctorIncentiveTesting({ id: row.id })
                .then(function(res: any) {
                    if (res.success) {
                        that.getDoctorIncentiveTestingList();
                        swal('Deleted', res.message, 'success');
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                });
        }, function(dismiss) { });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/doctorIncentiveTesting/doctorIncentiveTesting.component.ts